var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 56,
    viewBox: "0 0 67 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "triangle_bg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5125 3.17697C30.6623 -0.281645 36.087 -0.281645 38.2368 3.17697L65.9202 47.7141C68.0535 51.1461 65.3579 55.4164 61.0581 55.4164H5.69127C1.39147 55.4164 -1.30417 51.1461 0.829117 47.7141L28.5125 3.17697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3748 18.208V31.9125V18.208Z",
    fill: "#2B4A75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3748 18.208V31.9125",
    stroke: "#2B4A75",
    strokeWidth: 3.91667,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "circle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3747 47.5833C35.5378 47.5833 37.2913 45.8298 37.2913 43.6667C37.2913 41.5036 35.5378 39.75 33.3747 39.75C31.2116 39.75 29.458 41.5036 29.458 43.6667C29.458 45.8298 31.2116 47.5833 33.3747 47.5833Z",
    fill: "#2B4A75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWhite);
export default __webpack_public_path__ + "static/media/errorWhite.ca361a2304fd8c24e1323219e2b25ccc.svg";
export { ForwardRef as ReactComponent };